import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'amfori_site_ids'

export const dataPointDefinition = {
  retracedId: 'amfori_site_ids',
  name: 'amfori Site IDs',
  description:
    "The supplier's amfori business partner (format hint: '792-000179-000') and the Site IDs under it (format hint: '792-000179-002'), as one row: { businessPartnerId, siteIds }. A Site ID belongs to one supplier platform-wide; the sync links a supplier's first site and people add the others.",
  meta: {
    integration: 'AMFORI',
    format: '792-000179-002',
    isMultipleRow: false,
    columns: [
      {key: 1, id: 'businessPartnerId', name: 'BUSINESS_PARTNER_ID', text: 'Business Partner ID', type: 'SHORT_TEXT'},
      {key: 2, id: 'siteIds', name: 'SITE_IDS', text: 'Site IDs', type: 'SHORT_TEXT'},
    ],
  },
  fieldTypeId: 'TABLE',
  type: 'GLOBAL',
  options: [],
  schema: valueSchema,
  externalIds: [],
  sortingId: 37870,
  sectionId: '1.2',
  impactArea: 'Other IDs',
  impactAreaId: 'OTHER_IDS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
